<template>
  <div class="diadin">

    <div class="title">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-input class="cinput" :placeholder="$t('menu.Bykeywords')" clearable v-model="formInline.title"></el-input>
          <el-button type="primary" @click="search">{{ $t('menu.search') }}</el-button>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" @click="updadio()">{{ $t('menu.AddTo') }}</el-button>
      </div>
      <div class="bonntbot">
        <el-tabs v-model="action" @tab-click="searchType">
          <el-tab-pane v-for="(item, index) in titleList" :key="index"
            :label="item.num !== 0 ? item.dictLabel + '(' + item.num + ')' : item.dictLabel"
            :name="item.dictValue"></el-tab-pane>

        </el-tabs>

        <div class="bonntbota">
        
        </div>

      </div>


    </div>

 <el-table  empty-text=" " :data="mation" style="width: 100%" stripe border highlight-current-row>
   <el-table-column prop="noticeTitle" :label="$t('menu.Title')" width="280"> </el-table-column>
      <el-table-column prop="noticeType" :label="$t('menu.cgwdlx')">
        <template slot-scope="scope">
          <p>{{ notType(scope.row.noticeType) }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="createBy" :label="$t('menu.fbwfbr')" width="120"> </el-table-column>
      <el-table-column prop="createTime" :label="$t('menu.ReleaseTime')" width="280"> </el-table-column>
       <el-table-column prop="noticeType" :label="$t('menu.Operation')">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="eder(scope.row)" >{{ $t('menu.Edit') }}</el-button>
               <el-button type="text" style="color: red;" size="mini" @click="dele(scope.row.id)" >{{ $t('menu.Delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>    
<div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total,sizes, prev, pager, next" :total="totale">
      </el-pagination>

    </div>





    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      :show-close="false" width="50%">
      <div class="pop">
        
      </div>
    </el-dialog>


    <el-dialog
      :title="uptitlename"
      :visible.sync="dialogVisiblea"
      width="50%"
      :before-close="handleClose">
        <div>
       
          <el-form ref="formup" :rules="rules" :model="upform" label-width="80px">
            <el-form-item :label="$t('menu.Title')" prop="noticeTitle"> 
             <el-input v-model="upform.noticeTitle"></el-input>
            </el-form-item>
            <el-form-item :label="$t('menu.Type')" prop="noticeType">
                <el-select class="cinput" v-model="upform.noticeType" :placeholder="$t('menu.Type')"
            clearable>
            <el-option  v-for="(item, index) in titleList" :key="index" :label="item.dictLabel"
              :value="item.dictValue"></el-option>
          </el-select>
            </el-form-item>
          <el-form-item :label="$t('menu.tongzhiduix')" prop="rowde">
             <div>
              <el-radio v-model="rowde" label="1">{{ $t('menu.quanbulss') }}</el-radio>
             </div>
             <div>
              <el-radio v-model="rowde" label="2">{{ $t('menu.zhidingreny') }}</el-radio>
             </div>
            </el-form-item>
            <el-form-item label="" v-if="rowde=='2'">
             
   
   
              <el-select v-model="dealerName" multiple  :placeholder="$t('menu.mingxc')" clearable>
               <el-option v-for="(item, index) in cartypelista" :key="index" 
                :label="item.dealerName " :value="item.id+''"></el-option>
               </el-select>
             
            </el-form-item>
             <el-form-item :label="$t('menu.congnir')"  prop="noticeContent">
              <div style="height: 400px;">
                 <quill-editor ref="quill" style="height: 400px;" v-model="upform.noticeContent" class="editor" :options="editorOption"/>
                 <input type="file" @change="change" id="upload" style="display:none;" />
              </div>
             
             <!-- <el-input type="textarea" :rows="5" v-model="upform.noticeContent"></el-input> -->
            </el-form-item>
            <el-form-item :label="$t('menu.SelectFile')" style="margin-top: 200px;">
             <!-- <el-input v-model="upform.filePath"></el-input> -->
             <el-upload
          
               class="upload-demo"
                action="#"
                :http-request="uploadFile"
               :on-preview="handlePreview"
               :on-remove="handleRemove"
               :before-remove="beforeRemove"
               multiple
               :limit="5"
               :on-exceed="handleExceed"
               :file-list="fileupList">
               <el-button    size="small" type="primary">{{ $t('menu.Uploadfiles') }}</el-button>
               <div slot="tip" class="el-upload__tip">{{ $t('menu.Note10M') }}</div>
              </el-upload>
            </el-form-item>
          </el-form>  
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="quxiaol()">{{ $t('menu.Cancel') }}</el-button> 
        <el-button type="primary" @click="updatawendang()">{{ $t('menu.Confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import {  noticetLista,  querytype,upload,noticetup,noticetedr,deleNoticet,retailerlist } from "../../api/api";
import Utils  from "../../utils/uilt.js";
import { quillEditor, Quill } from 'vue-quill-editor';
import { container, ImageExtend } from 'quill-image-extend-module'
import {quillRedefine} from 'vue-quill-editor-upload'
Quill.register('modules/ImageExtend', ImageExtend)
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
export default {
  components:{
      quillEditor,quillRedefine
  },
  data () {
    return {
      detailsInfo: {},
      dialogVisible: false,
      dialogVisiblea:false,
      uptitlename:this.$t('menu.fabutongg'), 
      currentPage3: 1,
      pagesize: 10,
      totale: 3,
      activeNames: '',
       editorOption: {
          modules: {
          ImageExtend: {
              loading: true,  // 可选参数 是否显示上传进度和提示语
              name: 'img',  // 图片参数名
              size: 3,  // 可选参数 图片大小，单位为M，1M = 1024kb
              action: upload,  // 服务器地址, 如果action为空，则采用base64插入图片
              // response 为一个函数用来获取服务器返回的具体图片地址
              // 例如服务器返回{code: 200; data:{ url: 'xxx.com'}}
              // 则 return res.data.url
              response: (res) => {
                console.log(res);
                return res.data.data
              },
          
          },
          toolbar: {
            container: container,  // container为工具栏，此次引入了全部工具栏，也可自行配置
            handlers: {
              image: function(value) {
                if (value) {
                  document.querySelector('#upload').click()  // 劫持原来的图片点击按钮事件
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          }
        }
      },
      
      action: '',
      inle: 'zh',
      rowde:'1',
      dealerName:'',
      rules:{
         noticeTitle: [
            { required: true, message: '请输入', trigger: 'blur' },
          ],
        noticeType: [
           { required: true, message: '请选择', trigger: 'change' }
          ],
           rowde: [ { type: 'array', required: true, message: '请选择', trigger: 'change' } ],
           noticeContent: [
            { required: true, message: '请输入', trigger: 'blur' },
          ],
      },
      upform:{
        noticeTitle:'',
        noticeType:'',
        isAll:'0',
        retailers:'',
        noticeContent:'',
        file1Path:'',
        file2Path:'',
        file3Path:'',
        file4Path:'',
        file5Path:'',
      },
      fileupList:[],
      titleList: [
        {
          dictValue: '',
          dictLabel: this.$t('menu.All'),
          num: 0
        },
        // {
        //   dictValue: '',
        //   dictLabel: '零件变更（23）'
        // },
        // {
        //   dictValue: '',
        //   dictLabel: '服务公告（23）'
        // },
        // {
        //   dictValue: '',
        //   dictLabel: '培训材料'
        // },
        // {
        //   dictValue: '',
        //   dictLabel: '系统升级'
        // },
        // {
        //   dictValue: '',
        //   dictLabel: '活动通知'
        // },
      ],
      activeName: "first",
      mation: [], //列表
      formInline: {
        title: "",
        status: "",
        startTime: "",
        endTime: "",
        contact: "",
        category: "",
        type: "",
      },
      a: false,
      b: false,
      checked: false,
      num: [],
      cartypelista:[]
    };
  },
  created () {
    this.biao();
     this.querytypea()
     this.getQuerytypea()
    let a = sessionStorage.getItem('i18n')
    this.inle = a

  },
  filters: {
    cbjq: function (e) {
      let a =''
      let b =''
      // console.log(e);
      if(e!==null){
        a = e.split('/')
    
        b=a[a.length-1]
        
      }
      return b
  }
},
  
  methods: {
      change(e) {
        console.log(e);
        
      let file = e.target.files[0]
      const formData = new FormData()
       formData.append('category',e.target.files[0].type)
      formData.append('file', file)
       
      upload(formData)
        .then(res => {
       
          if (res.data.code == 200) {
            console.log(1,this.$refs.quill);
               let quill = this.$refs.quill.quill
               console.log(2,this.$refs.quill);
               
            // const formdata = _.extend({}, this.formdata)
            let length = quill.getSelection().index//光标位置
            // 插入图片  图片地址
            quill.insertEmbed(length, 'image', res.data.data)
            // 调整光标到最后
            quill.setSelection(length + 1)//光标后移一位
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
      //零售商
    getQuerytypea () {
 
      const params = new URLSearchParams()
      retailerlist( params, 1,1000).then(r => {
        console.log(r);
        this.cartypelista = r.data.rows;
    
      })
    },
    dele(e){
       this.$confirm(`确定移除？`).then( ()=> {
         let formdata = new FormData()
      deleNoticet(formdata,e).then(res=>{
        if(res.data.code == '200'){
          this.$message.success('成功')
          this.biao()
        } else {
          this.$message.error('失败')
        }
      })
        })
       
    },
    updadio(){
       this.uptitlename=this.$t('menu.fabutongg')
       this.fileupList=[]
       this.upform={
        noticeTitle:'',
        noticeType:'',
        isAll:'0',
        retailers:'',
        noticeContent:'',
        file1Path:'',
        file2Path:'',
        file3Path:'',
        file4Path:'',
        file5Path:'',
      }
      this.dialogVisiblea=true
    },
     cbjqac(e) {
      let a =''
      let b =''
      console.log(e);
      if(e!==null){
        a = e.split('/')
    
        b=a[a.length-1]
        
      }
      return b
     },
    eder(e){
       this.uptitlename= this.$t('menu.xiuggtongg')
     this.fileupList=[]
     let a =e
      this.upform=[]
      this.dealerName=[]
         this.upform={...a}
          if(e.isAll=='1'){
        this.rowde='1'
      
      }else{
        this.rowde='2'
        this.dealerName=this.upform.retailers
        //  this.upform.retailers=''
        console.log(this.dealerName);
        
      }
      if(e.file1Path!==''){
        let c={
          name:this.cbjqac(e.file1Path),
          url:e.file1Path
        }
         this.fileupList.push(c)
      }
      if(e.file2Path!==''){
        let c={
          name:this.cbjqac(e.file2Path),
          url:e.file2Path
        }
         this.fileupList.push(c)
      }
      if(e.file3Path!==''){
        let c={
          name:this.cbjqac(e.file3Path),
          url:e.file3Path
        }
         this.fileupList.push(c)
      }
      if(e.file4Path!==''){
        let c={
          name:this.cbjqac(e.file4Path),
          url:e.file4Path
        }
         this.fileupList.push(c)
      }
      if(e.file5Path!==''){
        let c={
          name:this.cbjqac(e.file5Path),
          url:e.file5Path
        }
         this.fileupList.push(c)
      }
         this.dialogVisiblea=true
    },
    quxiaol(){
      this.dialogVisiblea=false
      this.handleClose()
       this.biao();
    },
    updatawendang(){
       if(this.rowde=='1'){
        this.upform.isAll=1
      
      }else{
     
         this.upform.isAll=0
         this.upform.retailers=this.dealerName
      }
   
      let a =this.fileupList.length
      if(a==1){
        this.upform.file1Path=this.fileupList[0].url
        this.upform.file2Path=''
        this.upform.file3Path=''
        this.upform.file4Path=''
        this.upform.file5Path=''
      }
      if(a==2){
        this.upform.file1Path=this.fileupList[0].url
        this.upform.file2Path=this.fileupList[1].url
        this.upform.file3Path=''
        this.upform.file4Path=''
        this.upform.file5Path=''
      }
      if(a==3){
        this.upform.file1Path=this.fileupList[0].url
        this.upform.file2Path=this.fileupList[1].url
        this.upform.file3Path=this.fileupList[2].url
        this.upform.file4Path=''
        this.upform.file5Path=''
      }
      if(a==4){
        this.upform.file1Path=this.fileupList[0].url
        this.upform.file2Path=this.fileupList[1].url
        this.upform.file3Path=this.fileupList[2].url
        this.upform.file4Path=this.fileupList[3].url
        this.upform.file5Path=''
      }
       if(a==4){
        this.upform.file1Path=this.fileupList[0].url
        this.upform.file2Path=this.fileupList[1].url
        this.upform.file3Path=this.fileupList[2].url
        this.upform.file4Path=this.fileupList[3].url
        this.upform.file5Path=this.fileupList[4].url
      } 
    //   let aac =this.upform.noticeContent
    //  aac=JSON.parse( this.upform.noticeContent)
    //  this.upform.noticeContent=SON.stringify(aac)
      
      if( this.uptitlename==this.$t('menu.fabutongg')){
   
      
      noticetup(this.upform).then(res=>{
        if(res.data.code == '200'){
          this.$message.success('成功')
          this.upform={
              noticeTitle:'',
              noticeType:'',
              isAll:'0',
              retailers:'',
              noticeContent:'',
              file1Path:'',
              file2Path:'',
              file3Path:'',
              file4Path:'',
              file5Path:'',
           }
          this.biao()
       
        } else {
          this.$message.error('失败')
        }
      })
    
      }else{
        console.log(2,this.upform);
       
      // console.log(this.upform.noticeContent,this.upform.noticeContent.replace(/\//g,''));
        noticetedr(this.upform).then(res=>{
        if(res.data.code == '200'){
          this.$message.success('成功')
          this.upform={
              noticeTitle:'',
              noticeType:'',
              isAll:'0',
              retailers:'',
              noticeContent:'',
              file1Path:'',
              file2Path:'',
              file3Path:'',
              file4Path:'',
              file5Path:'',
           }
         
        this.biao()
        } else {
          this.$message.error('失败')
        }
      })
        
      }
      
     
      this.dialogVisiblea=false
      
    },
     uploadFile(file){
      console.log(file);
      
      let formdata = new FormData()
      formdata.append('file',file.file)
      formdata.append('category',file.file.type)
      upload(formdata).then(res=>{
        if(res.data.code == '200'){
          this.$message.success('上传成功')
           let a ={
              name:file.file.name,
              url:res.data.data
          }
          this.fileupList.push(a)
        } else {
          this.$message.error('上传失败')
        }
      })
    },
    notType(e){
      let a =''
      this.titleList.forEach((z=>{
        if(e==z.dictValue){
          a=z.dictLabel
        }
      }))
      return a
    },
     handleRemove(file, fileList) {
        console.log(1);
      },
      handlePreview(file) {
        console.log(2);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 5 个文件`);
      },
      beforeRemove(file, fileList) {
        // return this.$confirm(`确定移除 ${ file.name }？`).then( ()=> {
          this.deldx(file.url)
        // })

      },
      deldx(z){
      
          this.fileupList.forEach((e,i)=>{
            if(e.url==z){
                console.log(1);
                this.fileupList.splice(i,1)
            }else{
              
              
              // b.push(e)
              console.log(2);
            }
          })
          console.log(this.fileupList);
          
      },
      handleClose(){
         this.dialogVisiblea=false
      },

    
    searchType (tab, event) {
      this.action = tab.name
      this.biao()
     
    },
  
      sxtitle(e){
      let a =''
       
      if(this.inle=='zh'){
        a=e.dictLabel
      }
    if(this.inle=='en'){
      if(e.dictLabelEn.indexOf(":") !== -1){
       
        let c =JSON.parse(e.dictLabelEn)
     
        a=c.en
      }else{
        a=e.dictLabelEn
      }
      

      }
      if(this.inle=='de'){
         if(e.dictLabelEn.indexOf(":") !== -1){
             let d =JSON.parse(e.dictLabelEn)
a=d.de
         } else{
        a=e.dictLabelEn
      } 
         
      
      }
      return a

    },
 
    querytypea () {
      let param = new URLSearchParams();
      querytype(
        param,
        'sys_notice_type'
      ).then(r => {
         if (r.data.code == 200) {
          let a = this.titleList
          r.data.data.forEach(e => {
            let B = {
              dictLabel:this.sxtitle(e) ,
              dictValue: e.dictValue,
              num: 0
            }
          

            a.push(B)
          });
          this.num.forEach(e => {
            a.forEach((z, i) => {
              if (e.noticeType == z.dictValue) {
                a[i].num = e.sum
              }
            })

          })
          console.log(a);
          this.titleList = a


        }
      })
    },
    search () {
      this.biao()
    },
    async biao () {
      let param = new URLSearchParams();
      let noticeTitle = this.formInline.title;
      let noticeType =  this.action
      if(noticeType=='0'){
        noticeType=''
      }

      const { data: res } = await noticetLista(
        param,
        noticeTitle,
        noticeType,
        this.currentPage3,
        this.pagesize
      );

      this.mation = res.rows;
      this.num = res.summary
      this.totale = res.total;
     
    },
   
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
      this.pagesize=val
      this.biao()
    },
    handleCurrentChange (val) {
      // console.log(val);
      this.currentPage3=val
      this.biao();
    },
   
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.cinput {
  width: 300px;
  margin-right: 10px;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  padding-bottom: 10px;
  position: relative;


}

.bonntbota {
  position: absolute;
  right: 10px;
  top: 0;
}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.pop {
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;

    .btn1 {
      width: 100px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      background-color: #409eff;
    }
  }

  .content {
    margin-bottom: 20px;
  }
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-table th.is-leaf {
  text-align: left;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}
.cbjqq{
  margin-right: 10px;
  cursor: pointer;
  color: #409eff;
}
/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

.cctitle {
  color: #999999;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.btn {
  display: flex;
  justify-content: space-evenly;
  color: #31aff2;

  p {
    cursor: pointer;
  }
}

.title {
  padding-bottom: 10px;


  .status {
    display: flex;
    margin-top: 20px;

    div {
      margin-right: 25px;
      cursor: pointer;
    }
  }
}

.row-title {
  font-size: 18px;
  color: #222222;
  font-weight: 550;
}

.content-box {
  position: relative;
  background-color: #f2f2f2;
  border-radius: 10px;
  padding: 8px 4px;

  .qianshou {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>